import { render, staticRenderFns } from "./DTranslationErrors.vue?vue&type=template&id=2bca909a&scoped=true&"
import script from "./DTranslationErrors.vue?vue&type=script&lang=js&"
export * from "./DTranslationErrors.vue?vue&type=script&lang=js&"
import style0 from "./DTranslationErrors.vue?vue&type=style&index=0&id=2bca909a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca909a",
  null
  
)

export default component.exports